<template>
    <div
            style=" width: 100%; height: 100%; position: absolute;background-color: white;     overflow: auto; "
    >
        <div style="position: fixed;background: rgba(0, 0, 0, .075);width: 100%;height: 100%;z-index: 999" v-if="isLoading">
            <a-spin style="transform:translate(-50%,-50%);position: absolute;top: 50%; left: 50%;"/>
        </div>



        <el-container class="container">
            <br/>
            <h2 class="font-weight-bold">个人信息</h2>
            <h2 style="font-size: 18px;">Personal Information</h2>
            <br/>
            <el-header style="height: auto;padding:0 0;">
                <el-row style="display: flex; justify-content: center;">
                    <el-col :xs="0" :sm="1" :lg="3"></el-col>
                    <el-col
                            :xs="24"
                            :sm="22"
                            :lg="18"
                            style=" display: flex; justify-content: center;"
                    >
                        <el-form
                                ref="userForm"
                                :model="userForm"
                                label-width="0px"
                                :rules="rules"
                                style="width: 100%;"
                        >



                            <el-form-item prop="userName" label-width="0px">
                                <el-col :xs="22" :sm="22" :lg="20">
                                    <div class="div-label-wrapper" style="display: flex; align-items: center;">
                                        <!-- Label Wrapper -->
                                        <div class="label-wrapper" >
                                            <span class="label-chinese required">用户名</span>
                                            <span class="label-english">Name</span>
                                        </div>
                                        <!-- Input Wrapper -->
                                        <div style="flex-grow: 1; margin-top: 5px;">
                                            <el-input
                                                    v-model="userForm.userName"
                                                    placeholder="请填写用户名"
                                            ></el-input>
                                        </div>
                                    </div>
                                </el-col>
                            </el-form-item>



                            <el-form-item prop="phone" label-width="0px">
                                <el-col :xs="22" :sm="22" :lg="20">
                                    <div class="div-label-wrapper" style="display: flex; align-items: center;">
                                        <!-- Label Wrapper -->
                                        <div class="label-wrapper" >
                                            <span class="label-chinese required">电话</span>
                                            <span class="label-english">Phone Number</span>
                                        </div>
                                        <!-- Input Wrapper -->
                                        <div style="flex-grow: 1; margin-top: 5px;">
                                            <el-input
                                                    v-model="userForm.phone"
                                                    placeholder="请填写手机号或者电话 (例: 12345678912 或 0000-0000000)"
                                            ></el-input>
                                        </div>
                                    </div>
                                </el-col>
                            </el-form-item>




                            <el-form-item prop="addressInfo" label-width="0px">
                                <el-col :xs="22" :sm="22" :lg="20">
                                    <div class="div-label-wrapper" style="display: flex; align-items: center;">
                                        <!-- Label Wrapper -->
                                        <div class="label-wrapper" >
                                            <el-row >
                                                <span class="label-chinese required">地址</span>
                                                <span class="label-english">Address</span>
                                            </el-row>
                                            <el-row>
                                            </el-row>
                                        </div>
                                        <!-- Input Wrapper -->
                                        <div style="flex-grow: 1; margin-top: 5px;">


                                            <el-row style="display: flex;" >
                                            <el-form-item prop="province" >
                                                <el-select v-model="userForm.province" filterable placeholder="请选择省"  id="province"    @change="handleProvinceChange" >
                                                    <el-option v-for="(item,i) in provinceOptions" :key="i" :value="item" ></el-option>
                                                </el-select>
                                            </el-form-item>

                                             <el-form-item prop="city" >
                                                 <el-select v-model="userForm.city" filterable placeholder="请选择市"  v-if="userForm.province"  id="city"   @change="handleCityChange" >
                                                     <el-option v-for="(item,i) in cityOptions" :key="i" :value="item"></el-option>
                                                 </el-select>
                                             </el-form-item>

                                             <el-form-item prop="region"  >
                                                 <el-select v-model="userForm.region" filterable placeholder="请选择区/县"  v-if="userForm.city" id="region"    @change="handleRegionChange" >
                                                     <el-option v-for="(item,i) in regionOptions" :key="i" :value="item" ></el-option>
                                                 </el-select>
                                             </el-form-item>
                                            </el-row>


                                            <el-row>
                                                <el-input v-model="userForm.addressInfo" placeholder="请填写详细地址"></el-input>
                                            </el-row>

                                        </div>
                                    </div>
                                </el-col>
                            </el-form-item>



                            <el-form-item prop="expressCompany" label-width="0px">
                                <el-col :xs="22" :sm="22" :lg="20">
                                    <div class="div-label-wrapper" style="display: flex; align-items: center;">
                                        <!-- Label Wrapper -->
                                        <div class="label-wrapper" >
                                            <span class="label-chinese required">快递公司</span>
                                            <span class="label-english">Express Company</span>
                                        </div>
                                        <!-- Input Wrapper -->
                                        <div style="flex-grow: 1; margin-top: 5px;">
                                            <el-select v-model="userForm.expressCompany" placeholder="请选择快递公司">
                                                <el-option
                                                        v-for="item in expressCompanyList"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </el-col>
                            </el-form-item>



                            <el-form-item prop="trackingNumber" label-width="0px">
                                <el-col :xs="22" :sm="22" :lg="20">
                                    <div class="div-label-wrapper" style="display: flex; align-items: center;">
                                        <!-- Label Wrapper -->
                                        <div class="label-wrapper" >
                                            <span class="label-chinese required">快递单号</span>
                                            <span class="label-english">Tracking Number</span>
                                        </div>
                                        <!-- Input Wrapper -->
                                        <div style="flex-grow: 1; margin-top: 5px;">
                                            <el-input v-model="userForm.trackingNumber" placeholder="请填写快递单号"></el-input>
                                        </div>
                                    </div>
                                </el-col>
                            </el-form-item>
                        </el-form>
                    </el-col>

                    <el-col :xs="0" :sm="1" :lg="3"></el-col>
                </el-row>
            </el-header>

            <br/>
            <h2 class="font-weight-bold">洗护商品</h2>
            <h2  style="font-size: 18px;">Laundry Information</h2>
            <br/>

            <el-main  style="flex: none;padding: 5px 0px;">
                <el-row style="display: flex; justify-content: center;">
                    <el-col style="text-align: center;">
                        <span v-if=" picFileList.length > 0 ? false : true" style=" position: absolute;display: inline-block;padding-left: 30px;padding-top: 20px;color: red;font-size: 14px">此处添加商品图片 (Please Add Product Image)</span>
                        <el-upload style="margin-bottom: 30px"
                                :auto-upload="false"
                                action=""
                                class="upload-demo photo1"
                                ref="uploadPicRef"
                                list-type="picture-card"
                                :on-change="beforeUploadPic"
                                :on-remove="removePic"
                                :data="uploadData"
                                :file-list="picFileList"
                                :show-file-list="true"
                                :on-preview="handlePictureCardPreview"
                        >

                            <i
                                    class="el-icon-plus el-icon-plus-size"
                                    :style="
                  picFileList.length >= picFileListLimit
                    ? 'color: #ccc;'
                    : 'color: deepskyblue;'
                "
                            ></i>


                        </el-upload>

                        <el-dialog :visible.sync="dialogVisible">
                            <img width="100%" :src="dialogImageUrl" alt="" />
                        </el-dialog>

                    </el-col>
                    <!-- <el-col>  此处添加商品图片</el-col> -->
                </el-row>
                <el-row style="display: flex; justify-content: end;">

                </el-row>

                <el-row style="display: flex; justify-content: center;">
                    <el-col :xs="0" :sm="1" :lg="3"></el-col>
                    <el-col
                            :xs="24"
                            :sm="22"
                            :lg="18"
                            style=" display: flex; justify-content: center;"
                    >
                        <el-form
                                ref="userForm2"
                                :model="userForm"
                                label-width="0px"
                                :rules="rules"
                                style="width: 100%;"
                        >


                            <el-form-item prop="purchasingChannel" label-width="0px">
                                <el-col :xs="22" :sm="22" :lg="20">
                                    <div class="div-label-wrapper" style="display: flex; align-items: center;">
                                        <!-- Label Wrapper -->
                                        <div class="label-wrapper" >
                                            <span class="label-chinese required">请选择购买渠道</span>
                                            <span class="label-english">Purchasing Channel</span>
                                        </div>
                                        <!-- Input Wrapper -->
                                        <div style="flex-grow: 1; margin-top: 5px;">
                                            <el-select v-model="userForm.purchasingChannel" placeholder="请选择购买渠道"  @change="handleRemarks">
                                                <el-option
                                                        v-for="item in purchasingChannelList"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </el-col>
                            </el-form-item>




                            <el-form-item prop="num" label-width="0px">
                                <el-col :xs="22" :sm="22" :lg="20">
                                    <div class="div-label-wrapper" style="display: flex; align-items: center;">
                                        <!-- Label Wrapper -->
                                        <div class="label-wrapper" >
                                            <span class="label-chinese required">数量</span>
                                            <span class="label-english">Quantity</span>
                                        </div>
                                        <!-- Input Wrapper -->
                                        <div style="flex-grow: 1; margin-top: 5px;">
                                            <el-input v-model="userForm.num" placeholder="请填写数量"></el-input>
                                        </div>
                                    </div>
                                </el-col>
                            </el-form-item>



                            <el-form-item prop="remarks" label-width="0px">
                                <el-col :xs="22" :sm="22" :lg="20">
                                    <div class="div-label-wrapper" style="display: flex; align-items: center;">
                                        <!-- Label Wrapper -->
                                        <div class="label-wrapper" >
                                            <el-row >
                                                <span class="label-chinese no-required">脏污描述</span>
                                                <span class="label-english">Description of Problem</span>
                                            </el-row>
                                            <el-row>
                                            </el-row>
                                        </div>
                                        <!-- Input Wrapper -->
                                        <div style="flex-grow: 1; margin-top: 5px;">


                                            <el-row style="display: flex;" >
                                                <el-col >
                                                    <el-select v-model="remarksSelect" placeholder="请选择脏污类型"  @change="handleRemarks">
                                                        <el-option
                                                                v-for="item in remarksList"
                                                                :key="item.value"
                                                                :label="item.label"
                                                                :value="item.value">
                                                        </el-option>
                                                    </el-select>
                                                </el-col>

<!--                                                <el-col :xs="15" :sm="15" :lg="15" >-->
<!--                                                    <el-input v-if="remarksFlag" style="margin-left: 2px;" v-model="userForm.remarks" placeholder="请填写脏污描述"></el-input>-->
<!--                                                </el-col>-->
                                            </el-row>

                                            <el-row>
                                                <el-input v-if="remarksFlag"  v-model="userForm.remarks" placeholder="请填写脏污描述"></el-input>
                                            </el-row>


                                        </div>
                                    </div>
                                </el-col>
                            </el-form-item>




                        </el-form>
                    </el-col>

                    <el-col :xs="0" :sm="1" :lg="3"></el-col>
                </el-row>


            </el-main>
            <br/>
            <h2 class="font-weight-bold">洗护服务</h2>
            <h2  style="font-size: 18px;">Laundry Service</h2>
            <br/>
            <el-footer class="el-footer" style="height: auto;padding:0px 0px">
                <el-row style="display: flex; justify-content: center;padding:0px 0 20px ">
<!--                    <el-col :xs="3" :sm="3" :lg="6"/>-->
                    <el-col :xs="23" :sm="23" :lg="23">
                        <span v-if="userForm.paymentType == '1' ? true : false" style="display: block;text-align: center;font-size: 14px;color: red;">自费用户需上传付款凭证</span>
                        <span v-if="userForm.paymentType == '1' ? true : false" style="display: block;text-align: center;font-size: 14px;color: red;">Upload Payment Vouchers for Self-paying Customer</span>
                    </el-col>
<!--                    <el-col :xs="3" :sm="3" :lg="6" />-->
                </el-row>
                <el-row style="display: flex; justify-content: center;padding: 0px 20px; ">
                    <el-col :xs="6" :sm="6" :lg="9"/>
                    <el-col :xs="6" :sm="6" :lg="3" style="display: flex;flex-direction: column;">
                        <el-radio v-model="userForm.paymentType" label="1" @change="handlePaymentTypeChange">自费</el-radio>
                        <span>Self-paying</span>
                    </el-col>
                    <el-col :xs="6" :sm="6" :lg="3" style="display: flex;flex-direction: column;">
                        <el-radio v-model="userForm.paymentType" label="2" @change="handlePaymentTypeChange">免费</el-radio>
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Free</span>
                    </el-col>
                    <!--            <el-col :xs="12" :sm="12" :lg="6"-->
                    <!--                <el-radio-group v-model="userForm.paymentType" @change="handlePaymentTypeChange">-->
                    <!--                    <el-radio :label="1">付费</el-radio>-->
                    <!--                    <el-radio :label="2">免费</el-radio>-->
                    <!--                </el-radio-group>-->
                    <!--            </el-col>-->
                    <el-col :xs="6" :sm="6" :lg="9" />
                </el-row>

                <!-- <el-row
                  style="margin-top: 5px"
                  pingv-if="userForm.paymentType == '1' ? true : false"
                >
                  上传凭证
                </el-row> -->
                <br/>
                <el-row style="display: flex; justify-content: center;" v-if="userForm.paymentType == '1' ? true : false">
<!--                    <el-col :xs="0" :sm="1" :lg="3"></el-col>-->
                    <el-col
                            :xs="24"
                            :sm="22"
                            :lg="18"
                            style=" display: flex; justify-content: left;flex-direction: column;"
                    >
                        <span class="required" style="font-size: 14px">上传凭证</span>
                        <span class="no-required" style="font-size: 14px">Upload Payment Vouchers</span>
                    </el-col>

<!--                    <el-col :xs="0" :sm="1" :lg="3"></el-col>-->
                </el-row>

                <br/>


                <el-row
                        v-if="userForm.paymentType == '1' ? true : false"
                        style="display: flex; justify-content: center;"
                >
                    <el-col style="text-align: center;">
                        <el-upload
                                :auto-upload="false"
                                class="upload-demo photo2"
                                ref="uploadPicRef"
                                action=""
                                list-type="picture-card"
                                :on-change="beforeUploadPic2"
                                :on-remove="removePic2"
                                :data="uploadData2"
                                :file-list="picFileList2"
                                :show-file-list="true"
                                :on-preview="handlePictureCardPreview2"
                        >
                            <i
                                    class="el-icon-plus el-icon-plus-size"
                                    :style="
                  picFileList2.length >= picFileList2Limit
                    ? 'color: #ccc;'
                    : 'color: deepskyblue;'
                "
                            ></i>
                        </el-upload>
                        <el-dialog :visible.sync="dialogVisible2">
                            <img :span="6" width="100%" :src="dialogImageUrl2" alt="" />
                        </el-dialog>
                    </el-col>
                </el-row>

                <el-row
                        v-else
                        style="display: flex; justify-content: center;margin-top: 10px"
                >
                    <el-col :xs="0" :sm="1" :lg="3"></el-col>
                    <el-col
                            :xs="24"
                            :sm="22"
                            :lg="18"
                            style=" display: flex; justify-content: center;"
                    >


                        <el-form
                                ref="userForm3"
                                :model="userForm"
                                label-width="0px"
                                :rules="rules"
                                style="width: 100%;"
                        >


<!--                            -->
<!--                            <el-form-item label="卡号:" prop="cardNo">-->
<!--                                <el-col :xs="22" :sm="22" :lg="20">-->
<!--                                    <el-input v-model="userForm.cardNo" placeholder="请填写卡号"></el-input>-->
<!--                                </el-col>-->
<!--                            </el-form-item>-->


                            <el-form-item prop="cardNo" label-width="0px">
                                <el-col :xs="22" :sm="22" :lg="20">
                                    <div class="div-label-wrapper" style="display: flex; align-items: center;">
                                        <!-- Label Wrapper -->
                                        <div class="label-wrapper" >
                                            <span class="label-chinese required">卡号</span>
                                            <span class="label-english">Card Number</span>
                                        </div>
                                        <!-- Input Wrapper -->
                                        <div style="flex-grow: 1; margin-top: 5px;">
                                            <el-input v-model="userForm.cardNo" placeholder="请填写卡号"></el-input>
                                        </div>
                                    </div>
                                </el-col>
                            </el-form-item>


                        </el-form>






                    </el-col>

                    <el-col :xs="0" :sm="1" :lg="3"></el-col>
                </el-row>

<!--                v-if="userForm.paymentType == '1' ? true : false"-->

                <el-row style="display: flex; justify-content: center;" >

                    <el-col
                            :xs="24"
                            :sm="22"
                            :lg="18"
                            style=" display: flex; justify-content: left;flex-direction: column;"
                    >
                        <el-col>
                            <a-checkbox v-model="userForm.checkDisclaimer" ></a-checkbox>
                            <span style="cursor: pointer;margin-left: 10px;text-decoration: underline;font-size: 14px;" @click="exceptionsClick">免责条款</span>
                        </el-col>
                        <el-col style="position: absolute;top: 17px;padding-left: 16px;">
                            <span style="cursor: pointer;margin-left: 10px;font-size: 14px;"  @click="exceptionsClick" >Disclaimer Clause</span>
                        </el-col>
                    </el-col>

                    <!--                    <el-col :xs="0" :sm="1" :lg="3"></el-col>-->
                </el-row>

                <el-row
                        style="display: flex; justify-content: center;margin: 50px 0px;"
                >
                    <el-col :xs="8" :sm="8" :lg="8" style="text-align: end;">
                        <a-button @click="returnHome" style="background-color: #dae3f3;width: 100px;height: 40px;padding: 0px 0px;">
                           <div style="display: flex;flex-direction: column;justify-content: center;line-height: 15px;">
                               <span style="padding-top: 4px;">返回</span>
                               <span style="padding-bottom: 2px;">Back to Menu</span>
                           </div>
                        </a-button>

                    </el-col>
                    <el-col :xs="8" :sm="8" :lg="8" />
                    <el-col :xs="8" :sm="8" :lg="8" style="text-align: start;">
                        <!-- <el-button  @click="saveOrder">保存</el-button> -->
                        <!-- <el-button type="text" @click="showConfirm">保存</el-button> -->

                        <!-- <a-button @click="showConfirm">Confirm</a-button> -->


                        <a-button @click="confirm" style="background-color: #dae3f3;width: 100px;height: 40px;padding: 0px 0px;">
                            <div style="display: flex;flex-direction: column;justify-content: center;line-height: 15px;">
                                <span style="padding-top: 4px;">保存</span>
                                <span style="padding-bottom: 2px;">Save</span>
                            </div>
                        </a-button>

                    </el-col>
                </el-row>
            </el-footer>
        </el-container>

        <a-modal v-model="isModalVisible" id="cleaningRange" @cancel="handleCancel" :footer="null"  class="custom-modal"  >
            <template #title >
                <div>
                    <p>清洗范围外：</p>
                    <p style="font-size: 12px">Exclusions from Cleaning：</p>
                </div>
            </template>
                <el-row style="display: flex;">
                    <el-col span="1">1.</el-col>
                    <el-col>
                        <p>含皮草、真皮/ P U、皮革类、真丝类材质的服装（包括拼接款）<span style="display: block;">Garments containing fur, genuine leather/PU, leatherette, and silk fabrics (including those with patchwork designs)</span> </p>
                    </el-col>
                </el-row>

            <el-row style="display: flex;">
                <el-col span="1">2.</el-col>
                <el-col>
                    <p>旗袍、婚纱、演出服、礼服、少数民族等服饰<span style="display: block;">Cheongsams, wedding dresses, performance costumes, evening gowns, and ethnic minority attire</span> </p>
                </el-col>
            </el-row>

            <el-row style="display: flex;">
                <el-col span="1">3.</el-col>
                <el-col>
                    <p>价值超过2 0 0 0元有明星签字或纪念意义服装<span style="display: block;">Garments valued over 2,000 yuan, those with celebrity autographs, or those of sentimental or commemorative value</span> </p>
                </el-col>
            </el-row>


            <el-row style="display: flex;">
                <el-col span="1">4.</el-col>
                <el-col>
                    <p>毛领等毛绒类配饰<span style="display: block;">Fur accessories such as fur collars</span> </p>
                </el-col>
            </el-row>


            <el-row style="display: flex;">
                <el-col span="1">5.</el-col>
                <el-col>
                    <p>具有重大洗涤风险服装<span style="display: block;">Clothing with significant risk associated with cleaning</span> </p>
                </el-col>
            </el-row>

            <el-row style="display: flex;">
                <el-col span="1">6.</el-col>
                <el-col>
                    <p>宠物服装、大面积血迹衣物<span style="display: block;">Pet clothing and garments with large areas of bloodstains</span> </p>
                </el-col>
            </el-row>


            <el-row style="display: flex;">
                <el-col span="1">7.</el-col>
                <el-col>
                    <p>衣物、医疗相关衣物<span style="display: block;">Medical-related clothing and garments</span> </p>
                </el-col>
            </el-row>

            <el-row style="display: flex;">
                <el-col span="1">8.</el-col>
                <el-col>
                    <p>丧失穿着价值的衣物<span style="display: block;">Clothing that has lost its wearing value</span> </p>
                </el-col>
            </el-row>


            <el-row style="display: flex;">
                <el-col span="1">9.</el-col>
                <el-col>
                    <p>含金粉、亮片、五金、电子配饰等衣物 <span style="display: block;">Garments adorned with gold powder, sequins, hardware, electronic accessories, etc.</span> </p>
                </el-col>
            </el-row>

        </a-modal>
    </div>
</template>

<script>
    import ajax from "../../api/ajax";
    import api from "../../api/url";
    import { mapState } from "vuex";
    import axios from "axios";
    import cookie from "../../api/cookie";
    import { regionData,pcaTextArr } from 'element-china-area-data'

    export default {
        name: "customerInfo",
        computed: {
            provinceOptions(){
                return this.pcaTextArr.map(item => item.value).filter(value => value !== undefined);
            }
        },
        data() {
            return {
                isModalVisible: false,
                remarksSelect: null,
                remarksFlag: false,
                purchasingChannelList:[{label: '线下门店', value: '线下门店' },
                    {label: '天猫', value: '天猫' },
                    {label: '京东', value: '京东' },
                    {label: '抖音', value: '抖音' },
                    {label: '小程序', value: '小程序' },
                ],
                remarksList:[
                    { label: '污渍', value: '污渍' },
                    { label: '油渍', value: '油渍' },
                    { label: '染色', value: '染色' },
                    { label: '氧化', value: '氧化' },
                    { label: '胶印', value: '胶印' },
                    { label: '发霉', value: '发霉' },
                    { label: '发黄', value: '发黄' },
                    { label: '其他', value: '其他' }

                ],
                expressCompanyList:[  { label: '顺丰快递', value: '顺丰快递' },
                    { label: '中通快递', value: '中通快递' },
                    { label: '韵达快递', value: '韵达快递' },
                    { label: '圆通速递', value: '圆通速递' },
                    { label: '申通快递', value: '申通快递' },
                    { label: '百世快递', value: '百世快递' },
                    { label: '邮政EMS', value: '邮政EMS' },
                    { label: '京东快递', value: '京东快递' },
                    { label: '极兔快递', value: '极兔快递' },
                    { label: '天天快递', value: '天天快递' },
                    { label: '德邦快递', value: '德邦快递' },
                    { label: '其他', value: '其他' }],
                options: regionData,
                pcaTextArr,
                selectedOptions: [],
                userForm: {
                    userName: "",
                    phone: "",
                    expressCompany:"",
                    trackingNumber: "",
                    purchasingChannel:"",
                    num: "",
                    remarks: "",
                    paymentType: "1",
                    cardNo: "",
                    province: '',
                    city : '',
                    region : '',
                    addressInfo:'',
                    checkDisclaimer: false
                },
                cityList: [],
                cityOptions :[],
                regionOptions: [],

                isLoading: false,
                rules: {
                    userName: [
                        { required: true, message: "请输入用户名", trigger: "blur" },
                    ],
                    phone: [
                        { required: true, message: "请输入手机号或电话号码", trigger: "blur" },
                        { validator: this.validatePhone, trigger: 'blur' }
                    ],
                    purchasingChannel: [
                        { required: true, message: "请选择购买渠道", trigger: "blur" }
                    ],
                    addressInfo: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
                    expressCompany: [{required: true, message: "请输入快递公司", trigger: "blur"}],
                    trackingNumber: [
                        { required: true, message: "请输入快递单号", trigger: "blur" },
                    ],
                    num: [{ required: true, message: "请输入数量", trigger: "blur" }],
                    remarks: [{ required: false, message: "请输入备注", trigger: "blur" }],
                    cardNo: [{ required: true, message: "请输入卡号", trigger: "blur" }],
                    province: [{ required: true, message: " ", trigger: "blur" }],
                    city : [{ required: true, message: " ", trigger: "blur" }],
                    region : [{ required: true, message: " ", trigger: "blur" }],
                },

                uploadData: {
                    trackingNo: "",
                },
                uploadData2: {
                    trackingNo: "",
                },
                picFileList: [],
                picFileListLimit: 4,

                dialogVisible: false,
                dialogImageUrl: "",
                dialogVisible2: false,
                dialogImageUrl2: "",
                picFileList2: [],
                picFileList2Limit: 1,
                formDate1: new FormData(),
                borderColor: 'red' // 初始边框颜色
            };
        },
        watch: {
            picFileList(newValue, oldValue) {
                // 限制张数
                let flag = true;
                if (newValue.length == this.picFileListLimit) {
                    flag = false;
                }
                const fileInput = document.querySelector(".photo1");
                if (fileInput) {
                    const childElements = fileInput.querySelectorAll("div");
                    childElements.forEach((div) => {
                        if (flag) {
                            div.style.pointerEvents = "auto";
                        } else {
                            div.style.pointerEvents = "none";
                        }
                    });
                }
            },
            picFileList2(newValue, oldValue) {
                // 限制张数
                let flag = true;
                if (newValue.length == this.picFileList2Limit) {
                    flag = false;
                }
                const fileInput = document.querySelector(".photo2");
                if (fileInput) {
                    const childElements = fileInput.querySelectorAll("div");
                    childElements.forEach((div) => {
                        if (flag) {
                            div.style.pointerEvents = "auto";
                        } else {
                            div.style.pointerEvents = "none";
                        }
                    });
                }
            },
        },
        methods: {
            handleCancel() {
                this.isModalVisible = false;
            },
            exceptionsClick(){
                console.info('99999999')
                this.isModalVisible = true;
            },
            handlePaymentTypeChange(newValue){
                if (this.userForm.paymentType == '1'){
                    this.userForm.cardNo=''
                }else {
                    this.picFileList2 = []
                }
            },
            handleRemarks(remarks){
                if('其他' == remarks){
                    this.remarksFlag = true;
                    this.userForm.remarks = ''
                }else{
                    this.remarksFlag = false;
                    this.userForm.remarks = this.remarksSelect;
                }

            },
            validatePhone(rule, value, callback) {
                // 正则表达式：手机号（中国）或电话号码（固定电话）
                console.info('8888')
                const phoneRegex = /^1[3-9]\d{9}$|^(\d{3,4}-\d{7,8})$/;
                if (!value) {
                    return callback(new Error('请输入手机号或电话号码'));
                } else if (!phoneRegex.test(value)) {
                    return callback(new Error('手机号或电话号码格式不正确'));
                } else {
                    callback();
                }
            },
            handleRegionChange(region){
                this.userForm.region = region;

                const selectElement = document.getElementById('region');
                if (selectElement) {
                    selectElement.style.borderColor = `#DCDFE6`;
                }
            },
            handleCityChange(city){
                this.userForm.city = city;
                const index = this.cityList.findIndex(item => item.value === city);
                this.regionOptions =   this.cityList[index].children.map(item => item.value).filter(value => value !== undefined);


                const selectElement = document.getElementById('city');
                if (selectElement) {
                    selectElement.style.borderColor = `#DCDFE6`;
                }

            },
            handleProvinceChange(province){
                this.userForm.province = province;
                const index = this.pcaTextArr.findIndex(item => item.value === province);
                this.cityList = this.pcaTextArr[index].children;
                this.cityOptions = this.pcaTextArr[index].children.map(item => item.value).filter(value => value !== undefined);
                this.userForm.city = '';
                this.userForm.region = '';

                const selectElement = document.getElementById('province');
                if (selectElement) {
                    selectElement.style.borderColor = `#DCDFE6`;
                }


            },
            handleChange (value) {
                console.info(value)
                console.info(this.selectedOptions)

            },

            confirm() {

                if (! this.userForm.checkDisclaimer){
                    this.$message.warning('请勾选免责条款');
                    return;
                }

                if (this.userForm.paymentType == "1" && this.picFileList2.length == 0) {
                    this.$message.warning('上传凭证不允许为空');
                    return;
                }


                let that = this;
                this.$confirm({
                    title: "确认",
                    content: "请确认信息",
                    okText: "确认",
                    cancelText: "返回",
                    onOk() {
                        let error = false;

                        that.$refs["userForm"].validate((valid) => {
                            if (valid) {
                            } else {
                                error = true;
                            }
                        });

                        that.$refs["userForm2"].validate((valid) => {
                            if (valid) {
                            } else {
                                error = true;
                            }
                        });

                        if (that.userForm.paymentType == "2") {
                            that.$refs["userForm3"].validate((valid) => {
                                if (valid) {
                                } else {
                                    error = true;
                                }
                            });
                        }



                        if(that.userForm.province == '' ||  that.userForm.province == null){
                            const selectElement = document.getElementById('province');
                            if (selectElement) {
                                selectElement.style.borderColor = `red`;
                                error = true;
                            }
                        }


                        if(that.userForm.city  == '' ||  that.userForm.city  == null){
                            const selectElement = document.getElementById('city');
                            if (selectElement) {
                                selectElement.style.borderColor = `red`;
                                error = true;
                            }
                        }


                        if(that.userForm.region  == '' ||  that.userForm.region  == null){
                            const selectElement = document.getElementById('region');
                            if (selectElement) {
                                selectElement.style.borderColor = `red`;
                                error = true;
                            }
                        }




                        if (error) {
                            return;
                        }


                        that.isLoading = true;
                        const formData = new FormData();
                        that.picFileList.forEach(function(item, index) {
                            formData.append("beforeWashPhotos", item.raw, item.name);
                        });
                        that.picFileList2.forEach(function(item, index) {
                            formData.append("voucherPhotos", item.raw, item.name);
                        });


                        formData.append("mooseCleaningInfoVo", JSON.stringify(that.userForm));


                        ajax.post(api.MOOSECLEAN, formData).then((res) => {
                            that.isLoading = false;
                            if (res.code == 200) {
                                that.$message.success('保存成功');
                                that.userForm = {
                                    userName: "",
                                    phone: "",
                                    expressCompany:"",
                                    trackingNumber: "",
                                    purchasingChannel:"",
                                    num: "",
                                    remarks: "",
                                    paymentType: "1",
                                    cardNo: "",
                                    province: '',
                                    city : '',
                                    region : '',
                                    addressInfo:'',
                                    checkDisclaimer: false
                                },
                                    that.remarksSelect = null;
                                that.picFileList = [];
                                that.picFileList2 = [];
                            } else {
                                that.$message.warning(res.msg);
                            }
                        });
                    },
                });
            },

            saveOrder() {


            },

            returnHome() {
                this.$router.push({ path: "/moose/home" });
            },

            beforeUploadPic(file, fileList) {
                this.picFileList = fileList;
            },



            removePic(file, fileList) {
                this.picFileList = fileList;
            },

            beforeUploadPic2(file, fileList) {
                this.picFileList2 = fileList;
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },


            removePic2(file, fileList) {
                this.picFileList2 = fileList;
            },

            handlePictureCardPreview2(file) {
                this.dialogImageUrl2 = file.url;
                this.dialogVisible2 = true;
            },

        },
    };
</script>

<style scoped>
    .custom-modal >>> .ant-modal-title {
        font-weight: 600 !important;  /* 加粗标题文字 */
    }
    .required::before {
        content: '*';
        color: red;
        margin-right: 5px; /* 可根据需要调整间距 */
    }
    .no-required{
        padding-left: 10px;
    }


    #beizhu >>> .el-form-item__label{
        padding-left: 10px !important;
    }
    .el-icon-plus-size {
        font-size: 60px;
        margin: 20px;
    }

    .font-weight-bold {
        font-size: 25px;
        font-weight: bold;
    }
    .container >>> .el-form-item__label {
        text-align: left;
        vertical-align: middle;
        float: left;
        font-size: 14px;
        color: #606266;
        line-height: 40px;
        padding: 0 12px 0 0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        font-weight: normal !important;
    }
    .container {
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 20px;
    }


    .label {
        margin-right: 10px;
    }


    .upload-demo {

    }

    .upload-demo >>> .el-upload__input {
        display: none; /* 隐藏文件选择按钮 */
    }

    .upload-demo >>> .el-upload-list--picture-card .el-upload-list__item {
        overflow: hidden;
        background-color: #fff;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 120px;
        height: 120px;
        margin: none;
        display: inline-block;
    }

    .upload-demo >>> .el-upload--picture-card {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 40px;
        height: 40px;
        line-height: 38px;
        vertical-align: top;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    }
#cleaningRange >>> .ant-modal-header{
    padding: 20px 10px 5px 10px;
}
    .upload-demo >>> ul {
        margin-top: 50px;
    }
    .upload-demo >>> .el-upload-list--picture-card {
        display: inline-block !important;
    }

    .upload-demo >>> .el-upload--picture-card i {
        font-size: 20px !important;
        margin: 10px !important;
    }
    /* 样式调整，确保 NAME 与标签对齐 */
    .div-label-wrapper {
        display: flex;
        align-items: center; /* 确保输入框与中文、英文标签垂直对齐 */
    }

    .label-wrapper {
        /*display: flex;*/
        /*flex-direction: column; !* 垂直排列中文和英文 *!*/
        /*justify-content: center;*/
        /*margin-right: 10px; !* 适当设置中文、英文标签与输入框之间的间距 *!*/
        flex-shrink: 0;
        width: 165px;
        /*width: 85px;*/
    }


    .label-chinese {
        display: inline-block; /* 确保电话和Phone能够在一行显示 */
        font-size: 14px;
    }

    .label-english {
        display: block; /* 使Phone换行 */
        font-size: 14px; /* 设置英文的字体大小 */
        color: #666; /* 设置英文的颜色 */

        position: absolute;
        top: 17px;
        left: 10px;
    }

    /* 提高选择器优先级 */
    /* 增加更具体的选择器 */
    .el-form-item >>> .el-form-item__error{
        color: #F56C6C;
        font-size: 12px;
        line-height: 1;
        padding-top: 4px;
        position: absolute;
        top: 100%;
        left: 165px;
    }
</style>
